import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.988}
    height={20.496}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 100863 79547"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:1117.75}.fil1{fill:#1c1b17}.fil0{fill:#000}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541810688">
        <path
          d="M82448 45750c109 167 59-100 208 453 38 143 53 373 63 527 310 4728-1277 9664-3527 13617-1715 3011-5966 8116-9107 9152l12363-23749zm192-4760L69035 66945c-1477 2876-2554 6433-5162 6661-1503 130-4794-1743-5391-2569-1733-2395 681-5200 2299-8320l8179-15551c917-1733 1766-3464 2708-5199 908-1675 1773-3661 2736-5174 1461-2298 3662-1452 5363-537 1013 543 1679 807 2336 1542 679 760 980 1999 537 3192zM47264 29204c0 7309-7930 9206-11607 4637-1236-1535-1423-3200-1420-5569V7180c0-4481-446-4554 2489-4554h8687c1845 0 1849 487 1851 2226v24352zM30678 53695c-1225-424-6557-3402-8279-4269-1383-695-2692-1386-4075-2134-934-503-3321-1520-3897-2186-1541-177-4998-2821-6182-3861-1524-1336-3067-3454-4120-5809-2335-5219-1765-11448 896-16068 2181-3786 6133-7281 11555-8463 3029-659 5968-528 8829 287 1739 496 5405 2240 6774 3167 206 4511 20 9507 16 14069-11 11249 10887 11947 15038 6938 2816-3397 2007-6926 2090-11924 889 198 4925 2463 5957 3025 1954 1066 3848 2031 5799 3042 2590 1342 9473 4839 11592 6108L56115 67044c-706-148-25290-13184-25437-13349zm1490-41771c-661-142-2080-1044-2822-1399C16782 4540 2640 12022 723 25908-4 31181 1791 36391 4188 39720c2678 3718 5210 5298 9867 7655 4078 2067 7628 3973 11493 6038 7654 4088 15389 7999 22993 12058 1899 1012 3742 2034 5687 3004 2149 1069 1145 356 1899 2445 1166 3239 8767 7658 12084 2024 485-823 421-611 1370-955 9237-3330 17312-17712 14740-28048-475-1904 208-1400 512-3228 216-1297-105-2630-661-3584-1033-1769-5718-4739-8805-3572-1544 586-704 756-3099-506L49317 21005c-35-4086-3-8186-3-12274 0-4443 948-8178-4055-8152-2016 9-4034 0-6051 0-5212 0-7015-642-7013 5205 0 1932 116 4255-27 6140zM84453 76410c-188-184-369-346-565-528-190-177-343-355-533-528-546-496-1152-1138-1652-1596l-1118-1068c-463-425-2425-2410-2746-2640-113 72-171 154-254 248 38 107 424 433 536 546 651 661 1528 1471 2206 2134l4939 4775c189 181 371 338 557 538 157 167 393 397 555 525l268-241c-58-140-176-196-273-303-99-112-167-162-270-263l-1111-1073c-179-160-347-336-539-526zM88236 52371l11990 2421c50-101 94-272 72-385l-11977-2418-85 382z"
          className="fil0"
        />
        <path
          d="M14736 39966c337-755 1394 60 1895 339l11292 5932c861 434 1427 384 1342 1433-768 489-1063 16-1912-408l-9363-4899c-712-378-1208-651-1926-1031-511-272-1687-559-1328-1366zm-653 2740c1183 404 2550 1290 3700 1878l7331 3825c1317 705 2419 1596 4168 1533 469-284 2281-651 2068-2906-141-1503-1248-2006-2410-2606-2234-1150-4382-2363-6608-3471-1142-570-5793-3220-6694-3328-1533-185-2665 739-2969 1955-512 2049 1199 2831 1414 3120z"
          style={{
            // stroke: "#000",
            strokeWidth: 1466.86,
          }}
          className="fil1"

        />
        <path
          d="M24527 36837c-1320-702-2467-1270-3765-1976-1319-718-3760-1571-2825-2341 573-473 6724 3090 7644 3568 1264 654 2499 1294 3761 1979 663 357 4003 1682 2772 2414-538 321-6752-3199-7587-3644zm-8823-3363c304 1632 2887 2602 4344 3347l10162 5335c2224 1166 4606-161 4200-2621-297-1779-2905-2655-4355-3418l-10166-5348c-2234-1182-4642 245-4185 2705z"
          style={{
            // stroke: "#1c1b17",
            strokeWidth: 1466.86,
          }}
          className="fil1"
        />
        <circle
          cx={40730}
          cy={29315}
          r={2147}
          style={{
            // stroke: "#1c1b17",
            strokeWidth: 2587.55,
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
